module.exports = __webpack_public_path__ + "static/media/md-archive.e337d196.svg";